import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import AddEditUom from "../../components/settings/data-setup/inventory/add-edit-uom-group";
import { uomGroupTableListAction } from "../../redux/actions/settings-action";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import InnerLayout from "../../components/layouts/inner-layout";
import { ChevronLeftIcon } from "lucide-react";
import errorToast from "../../components/helper-components/error-toast";

const UomGroupAddEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [editingData, setEditingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  // Check if we're in edit mode
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      // Get data from navigation state or fetch if not available
      const stateData = location.state?.editingData;
      if (stateData) {
        console.log("Using data from navigation state:", stateData);
        setEditingData(stateData);
      } else {
        // Fallback: try to fetch data (though this might not work with current API)
        console.log("No state data, attempting to fetch...");
        fetchUomGroupData();
      }
    } else {
      // For add mode, set empty data
      setEditingData({});
    }
  }, [id, isEditMode, location.state]);

  const fetchUomGroupData = () => {
    console.log("Fetching UOM group data for ID:", id);
    setLoading(true);
    dispatch(
      uomGroupTableListAction({ group_id: id }, onFetchSuccess, onFetchError)
    );
  };

  const onFetchSuccess = (data) => {
    console.log("---------------------------------------------------");
    console.log("UOM group fetch success:", data);
    if (data?.data && data.data.length > 0) {
      console.log("Setting editing data:", data.data[0]);
      setEditingData(data.data[0]);
    } else {
      console.log("No data found, redirecting back");
      // If no data found, redirect back to UOM group list
      navigate("/settings/uom-group-setup");
    }
    setLoading(false);
  };

  const onFetchError = (error) => {
    console.error("Error fetching UOM group data:", error);
    setLoading(false);
    // Redirect back to UOM group list on error
    navigate(-1);
  };

  const toogleChange = () => {
    // navigate(-1);
    console.log("Toggling reload and navigating back");
    fetchUomGroupData();
  };
  const confirmAndGoBack = () => {
    setShowLeaveConfirm(false);
    navigate(-1);
  };

  const handleBack = () => {
    if (hasUnsavedChanges) {
      setShowLeaveConfirm(true);
    }else{
      setShowLeaveConfirm(false);
      navigate(-1);
    }
  };

  const handleFormChange = (hasChanges) => {
    setHasUnsavedChanges(hasChanges);
  };

  if (loading || (isEditMode && !editingData)) {
    return (
      <InnerLayout>
        <div className="flex justify-center items-center h-64">
          <LoadingSpinner />
        </div>
      </InnerLayout>
    );
  }

  return (
    <InnerLayout title="Settings">
      <div className="flex items-center  py-3 mx-6 gap-2 text-sm">
        <button className="flex items-center gap-2" onClick={handleBack}>
          <ChevronLeftIcon className="h-5 w-5 inline-block" />
          Settings / UOM Group Setup /{" "}
          {isEditMode ? "Edit UOM Groups" : "Add UOM Groups"}
        </button>
      </div>

      <div className="w-full">
        <AddEditUom
          editingData={editingData}
          toogleChange={toogleChange}
          reload={reload}
          onFormChange={handleFormChange}
        />
      </div>
      {showLeaveConfirm && (
        <div className="fixed inset-0 z-[9999] grid place-items-center">
          <div
            className="absolute inset-0 bg-black opacity-30"
            onClick={() => setShowLeaveConfirm(false)}
          />
          <div className="relative w-[90%] max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-800">
              Leave without saving?
            </h3>
            <p className="mt-2 text-sm text-gray-600">
              All your changes will not be saved.
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg border border-[var(--remove-color)] bg-[var(--remove-color)] text-white hover:opacity-90"
                onClick={() => setShowLeaveConfirm(false)}
              >
                No
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-[var(--primary)] text-white hover:opacity-90"
                onClick={confirmAndGoBack}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </InnerLayout>
  );
};

export default UomGroupAddEdit;
